import React, { useContext } from "react";
import styled from "styled-components";
import Axios from "axios";
import { Helmet } from "react-helmet";
import { Label } from "reactstrap";

import LogoImage from "../../Resources/Images/logo_main.png";
import GlobalContext from "../../Hooks/globalContext";
import { HOST } from "../../Utils/constants";
import { languagePack } from "../../Utils/language";
import useState from "../../Hooks/useState";
import useInput from "../../Hooks/useInput";
import Input from "../../Components/Common/Input";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  min-height: 100vh;
  background: linear-gradient(160deg, #0B1A2E 0%, #132D4A 50%, #0F2236 100%);
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  margin-bottom: 36px;
`;

const AuthWrapper = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 24px;

  input {
    margin-bottom: 14px;
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 12px;
    color: #ffffff;
    padding: 14px 16px;
    font-size: 14px;
    transition: border-color 0.2s;
    ::placeholder {
      color: rgba(255,255,255,0.35);
    }
    :focus {
      border-color: #3D73AD;
      outline: none;
    }
  }
  button {
    margin: 6px 0;
  }
`;

const LengthWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 380px;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 20px;
  padding: 36px 28px;
  overflow: auto;
  overflow-x: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`;

const AuthButton = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #3D73AD 0%, #2A5A8F 100%);
  font-size: 15px;
  font-weight: 600;
  color: white;
  padding: 14px;
  border: 0;
  border-radius: 12px;
  letter-spacing: 0.5px;
  transition: opacity 0.2s, transform 0.1s;
  :hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }
  :active {
    transform: translateY(0);
  }
  :focus {
    outline: none;
  }
  cursor: pointer;
`;

const AuthLogo = styled.img`
  width: 220px;
  margin-bottom: 12px;
`;

const DevButton = styled.button`
  width: 100%;
  padding: 10px;
  margin-top: 8px;
  background: rgba(255, 50, 50, 0.15);
  border: 1px dashed rgba(255, 50, 50, 0.4);
  border-radius: 8px;
  color: rgba(255, 100, 100, 0.8);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  cursor: pointer;
  :hover {
    background: rgba(255, 50, 50, 0.25);
  }
`;

/** Container  */

const Container = ({ history }) => {
  const { isLogin, language, isSession, getUser, modal } = useContext(GlobalContext);
  const emailInput = useInput({ defaultValue: "" });
  const passwordInput = useInput({ defaultValue: "" });
  const isChecked = useState(false);

  const AuthOnSubmit = (e) => {
    e.preventDefault();

    const config = {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
    };

    const loginParams = {
      email: emailInput.value,
      password: passwordInput.value,
      type: "web",
    };

    Axios.post(`${HOST}/login`, loginParams, config)
      .then(async (response) => {
        if (response.data.status) {
          await getUser(response.data.token);
          isLogin.setState(true);
          if (isChecked.state) {
            localStorage.setItem("token", response.data.token);
            isSession.setState(false);
          } else {
            sessionStorage.setItem("token", response.data.token);
            isSession.setState(true);
          }
          history.replace("/");
        } else {
          switch (response.data.code) {
            case "invalid":
              modal.setState(languagePack("잘못된 ID 혹은 비밀번호입니다.", language.state));
              break;
            case "server":
              modal.setState(languagePack("서버 오류입니다. 잠시 후에 다시 시도해주세요.", language.state));
              break;
            default:
              modal.setState(languagePack("서버 오류입니다. 잠시 후에 다시 시도해주세요.", language.state));
              break;
          }
        }
      })
      .catch(() => {
        modal.setState(languagePack("서버 오류입니다. 잠시 후에 다시 시도해주세요.", language.state));
      });
  };

  return (
    <>
      <Wrapper>
        <AuthWrapper onSubmit={AuthOnSubmit}>
          <LengthWrapper>
            <LogoWrapper>
              <AuthLogo src={LogoImage} />
            </LogoWrapper>
            <Input placeholder="E-Mail" type="email" {...emailInput} />
            <Input placeholder="Password" type="password" {...passwordInput} />
            <AuthButton>{languagePack("로그인", language.state)}</AuthButton>
            {process.env.NODE_ENV === "development" && (
              <DevButton type="button" onClick={() => {
                Axios.post(`${HOST}/dev/login`).then(async (response) => {
                  if (response.data.status) {
                    await getUser(response.data.token);
                    isLogin.setState(true);
                    sessionStorage.setItem("token", response.data.token);
                    isSession.setState(true);
                    history.replace("/");
                  } else {
                    modal.setState("Dev 로그인 실패: " + (response.data.code || "unknown"));
                  }
                }).catch(() => modal.setState("Dev 서버 연결 실패"));
              }}>DEV LOGIN</DevButton>
            )}
          </LengthWrapper>
        </AuthWrapper>
      </Wrapper>
    </>
  );
};

export default Container;
